import type { OktaAuth } from '@okta/okta-auth-js'
import { storageKeys } from '../../config/global/okta.config'

interface AuthContext {
  $auth: OktaAuth
}

export async function signOut(this: AuthContext): Promise<void> {
  if (this.$auth) {
    await this.$auth.signOut()

    Object.values(storageKeys).forEach((tokenKey: string) => {
      localStorage.removeItem(tokenKey)
    })
  }
}
